import React from "react";

export default function LawtonExcellencePrinting() {
    return (
        <div className="pt-16 pb-48 max-w-4xl mx-auto px-4">
            <h2 className="font-din text-[35px] font-bold">Lawton Connect Celebrates 125 Years of Excellence in Printing</h2>
            <div className="font-ibm mt-3">
                <p>
                    <strong>Orlando, FL – March 03, 2025</strong> – <a href="/">Lawton Connect</a>, a premier leader in the printing industry,
                    proudly announces its 125th anniversary—a monumental milestone that reflects over a century
                    of delivering high-quality, innovative printing solutions to businesses nationwide. As one of the
                    oldest continuously operating printing companies in the United States, Lawton Connect
                    is poised for even greater success with exciting new developments, including state-of-the-art
                    equipment, a strengthened team, and an enhanced focus on customized client service.
                </p>
                <br />
                <h4 className="font-bold font-din text-xl mb-2">A Legacy of Innovation and Commitment</h4>
                <p>
                    Founded in 1900 by J. B. Lawton, Lawton Connect has remained at the forefront of the printing
                    industry by consistently adapting to market trends and embracing cutting-edge technologies.
                    The company’s history is a testament to its dedication to quality, customer satisfaction, and
                    innovation. <br /> <br/>
                    “Reaching 125 years is an incredible accomplishment, and it’s a reflection of our commitment to
                    providing exceptional printing services and cultivating lasting relationships with our clients and
                    partners,” said Kimberly Lawton Koon, President of Lawton Connect. “We’ve grown with the
                    industry and evolved to meet the changing needs of our customers, while never losing sight of
                    the values that brought us here.”
                </p> <br/>
                <h3 className="font-bold font-din text-xl mb-2">Looking to the Future</h3>
                <p className="mb-2">Lawton Connect is proud of key advancements that position the company for continued success:</p>
                <ul className="list-disc pl-5">
                    <li><strong>State-of-the-Art Equipment:</strong> Lawton Connect continues to invest in advanced printing
                        technology to deliver unmatched quality and efficiency. The company recently expanded
                        its capabilities by adding the RMGT 970-5 LED-UV press. This cutting-edge technology
                        enables faster turnaround times, superior print quality, and unparalleled versatility,
                        ensuring clients receive top-quality products for campaigns of any size.
                    </li>
                    <li><strong>Strategic Team Members:</strong> The company has welcomed key hires, bringing fresh
                        expertise and creative energy to enhance operations and better meet the needs of an
                        evolving marketplace.</li>
                    <li><strong>Customized Client Service:</strong> Lawton Connect remains dedicated to personalized
                        solutions, ensuring every client project is executed with attention to detail and tailored to
                        their unique goals.
                    </li>
                </ul>
                <br />
                <p className="">
                    “As we look ahead, we’re excited to continue driving innovation in the printing industry,” added
                    Lawton Koon. “This milestone isn’t just a celebration of our past five generations of Lawton
                    family legacy; it’s a launchpad for our next chapter.”
                </p>
                <br />
                <div className="mb-4">
                <div className="flex items-center justify-center mb-3"><img src="/LAW_RMGTPress_25_031.jpg" alt="" className="content-center"/></div>
                <span className="text-xs text-center">Kimberly Lawton Koon and Ty Koon with the new RMGT 970-5 LED-UV press.
                    Lawton Connect’s investment in advanced technology ensures faster turnaround times and superior print quality.
                </span>
                </div>
                <h4 className="font-bold font-din text-xl mb-2">About Lawton Connect:</h4>
                <p>
                    Lawton Connect delivers innovative printing solutions to brand-conscious clients. Lawton&apos;s
                    solutions combine traditional craftsmanship with cutting-edge technology, offering seamless
                    interfaces, enhanced communication, and measurable results across complete offset, digital,
                    fulfillment, and distribution capabilities. Founded in 1900, this family-owned legacy prioritizes
                    trust and frictionless experiences, empowering creators to efficiently realize their visions. <br/> <br/>
                    Lawton Connect is also home to three integrated brands that blend creativity and technology:
                    Mr. Playing Card, which specializes in custom affirmation and game cards; Mr. Scratch Off,
                    which focuses on scratch-off printing solutions; and Pinhole Press, which creates personalized,
                    photo-based products. <br/> <br/>
                </p>
            </div>
        </div>
    );
}
